const translations = {
  "en": {
    "Related News, or Latest News": "Related News, or Latest News"
  },
  "zh-tw": {
    "Related News, or Latest News": "相關新聞，或最新新聞"
  }
};

export default translations;
